/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
  /* 01.General */
  "general.copyright": "Myma.ai © 2019 All Rights Reserved.",

  'user.login-title': 'Login',
  'user.register': 'Register',
  'user.forgot-password': 'Forgot Password',
  'user.email': 'E-mail',
  'user.newpassword': 'New Password',
  'user.currentpassword': 'Current Password',
  'user.newpasswordagain': 'New Password Again',
  'user.password': 'Password',
  'user.forgot-password-question': 'Forget password?',
  'user.fullname': 'Full Name',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',


  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'Tickets',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.topic': 'Topic',
  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Say something..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',


  /* Property Info */
  'property-info.about-property': 'À propos de la propriété',
  'property-info.about-properties': 'À propos des propriétés',
  'property-info.facilities-services': 'Installations et services',
  'property-info.property-facilities': 'Installations de la propriété',
  'property-info.room-amenities': 'Commodités de la chambre',
  'property-info.property-contact': 'Contact de la propriété',
  'property-info.property-activities': 'Activités immobilières',
  'property-info.property-location': 'Emplacement de la propriété',
  'property-info.about-rooms': 'À propos des chambres',
  'property-info.about-sites': 'À propos des sites',
  'property-info.special-emergencies': 'Urgences',
  'property-info.gallery': 'Galerie',
  'property-info.policies': 'Stratégies',
  'property-info.nearby': 'Proche',
  'property-info.transport': 'Transport',
  'property-info.location': 'Emplacement',
  'property-info.about-rhproperty': 'À propos de la maison de retraite',
  'property-info.related-topics': 'Rubriques connexes',
  'property-info.assistant-options': "Options de l'assistant",
  'property-info.restaurant-assistant-information': 'Informations sur les restaurants',
  'property-info.restaurant-assistant-options': 'Message de bienvenue',
  'property-info.channel-messages': 'Messages de canal',
  'property-info.icon.gallery': "Galerie d'icônes",
  'property-info.copilot': 'Copilote',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Informations sur la maison',
  'property-info.loction': 'Emplacements',
  'property-info.rooms-and-images': 'Chambres & Images',
  'property-info.trainig-data': "Données d'entraînement",
  'property-info.flows': 'Les flux',
  'property-info.add-your-own': 'Ajouter votre propre',
  'property-info-utility-miscellaneous': 'Divers',
  'property-info-utility-payment': 'Paiements',
  'property-info-utility-broadband': 'Haut débit',
  'property-info-utility-emergency': 'Urgence',
  'property-info-utility-mobile': 'Mobile',
  'property-info-utility-moving': 'En mouvement',

  /** Rate & Promo */
  'rate-promo.rate-plans': 'Plans tarifaires',
  'rate-promo.rate-plan-addons': "Modules complémentaires",
  'rate-promo.rate-plan-promos': 'Promos',

  'title.property-information': 'Informations sur la propriété',

  'property.message': 'Un message',
  'property.example': 'Exemple',
  'property.link': 'Liens',
  'property.image-carousel': "Carrousel d'images",
  'property.Title': 'Titre',
  'property.SubTitle': 'Sous-titre',

  'property.add-invoke-api': 'Invoquer l`API',
  'property.add-message-button': 'Ajouter des messages',
  'property.add-img-button': 'Ajouter des images',
  'property.add-link-button': 'Ajouter un lien',
  'property.add-herocard-button': 'Ajouter une carte de héros',
  'property.add-api-button': 'Ajouter des boutons',

  'menu.about-property': 'À propos de la propriété',
  'menu.property-facilities': 'Installations de la propriété',
  'menu.room-amenities': 'Commodités de la chambre',
  'menu.property-contact': 'Contact de la propriété',
  'menu.about-rooms': 'À propos des chambres',
  'menu.special-emergencies': 'Urgences',
  'menu.show-filter': 'filtres',
  'menu.new': 'nouvelle',

  'dashboards.common-asked': 'Questions fréquemment posées',
  'dashboards.website-visitor-asking': 'Ce que les visiteurs du site Web demandent',
  'dashboards.visit-country': 'Visite du site Web par pays',
  'dashboards.visit-traffic': 'Pays du trafic du site Web',
  'dashboards.rooms-product': 'Chambres & Produits',
  'dashboards.popular-room-product': 'Chambres et produits populaires',

  'dashboards.messenger-stats': 'Éléments de menu populaires',
  'dashboards.messenger-stats-topic-view': 'Statistiques sur les vues des éléments de menu',
  'dashboards.messenger-stats-visits': 'Vues des éléments de menu',
  'dashboards.opening-menu-items': 'Nombre de visiteurs du site Web ouvrant des éléments de menu',

  'dashboards.number-totalavatarclick': "Nombre total de clics sur l'avatar",

  'dashboards.clicks': 'Clics',
  'dashboards.leads': 'Fils',
  'dashboards.hours': 'Heures',
  'dashboards.minutes': 'Minutes',

  'dashboards.ai-chatbot': 'Chatbot IA',
  'dashboards.compendium': 'Compendium',
  'dashboards.compendium-digital-usage': 'Utilisation du recueil numérique',
  'dashboards.compendium-unique-visits': 'Visites uniques',
  'dashboards.compendium-opening-menu-items': 'Nombre d`éléments de menu consultés',
  'dashboards.compendium-total-digital-clicks': 'Nombre total de clics sur le Recueil numérique',

  'property.delete': 'Effacer',
  'menu.userroles': 'Utilisateurs et rôles',
  'menu.ratebookings': 'Tarifs & Réservations',
  'dashboards.engagement-time': "Temps d'engagement de l'assistant numérique",
  'dashboards.conversations-minutes': 'Nombre total de minutes et nuit (de 19h à 7h) Minutes de conversations',
  'dashboards.visitor-questions': 'Questions des visiteurs',
  'dashboards.recent-queries': 'Requêtes récentes',
  'dashboards.visitor-saying': "Ce que vos visiteurs disent à l'assistant numérique",
  'dashboards.contacts-prechatform-leavemessage': 'Contacts stockés à partir du formulaire de pré-chat et laisser un message',
  'menu.dashboards': 'Connaissances',
  'menu.ari': 'Disponibilité et tarifs',
  'menu.conversations': 'Des conversations',
  'menu.conversations.unified-inbox': 'Boîte de réception unifiée',
  'menu.conversations.active': 'Discussions actives',
  'menu.conversations.archives': 'Les archives',
  'menu.conversations.missed-responses': 'Réponses manquées',
  'menu.conversations.ticket': 'Des billets',
  'menu.conversations.reply-templates': 'Modèles de réponse',
  'menu.bookings': 'Réservations et réservations',
  'menu.tickets': 'Leads et billets',
  'menu.propinfo': 'Centre de connaissances',
  'menu.rate-promos': 'Tarifs et promotions',
  'menu.finance': 'La finance',
  'menu.integration': 'Relier',
  'menu.admin': 'Admin et sécurité',
  'menu.favourites': 'Favoris',
  'menu.recommender': 'Flux de conversation',
  'menu.assistant-setup': `Configuration de l'assistant`,
  'menu.admin-insights': 'Informations sur l`administrateur',
  'menu.super-admin': 'Super administrateur',
  'menu.groups': 'Groupes',
  'menu.properties': 'Propriétés',
  'menu.service-provider': 'Fournisseurs de services',
  'menu.spaces': 'Espaces',

  'dashboards.space-booking': 'Réservation d`espace',
  'dashboards.gift-voucher': 'Chèques cadeaux',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'Depuis',
  'dashboards.to': 'À',
  'dashboards.active-groups': 'Groupes actifs',
  'dashboards.active-properties': 'Propriétés actives',
  'dashboards.live-properties': 'Propriétés en direct',
  'dashboards.properties-going': 'Propriétés mises en ligne par plage de dates',
  'dashboards.start-date': 'Date de début',
  'dashboards.end-date': 'Date de fin',

  'dashboards.website-visits': 'Visites du site Web',
  'dashboards.unique-visitors': 'visiteurs uniques',
  'dashboards.last-week': 'La semaine dernière',
  'dashboards.this-week': 'Cette semaine',
  'dashboards.this-month': 'Ce mois-ci',
  'dashboards.previous-month': 'Le mois précédent',
  'dashboards.yeartodate': 'Année à ce jour',
  'dashboards.lastyear': "L'année dernière",
  'dashboards.last-7-days': 'Les 7 derniers jours',
  'dashboards.last-30-days': 'Les 30 derniers jours',
  'dashboards.last-60-days': 'Les 60 derniers jours',
  'dashboards.last-90-days': 'Les 90 derniers jours',
  'dashboards.conversion-rates': 'Taux de conversion',
  'dashboards.digital-assistant-engagement': "Engagement de l'assistant numérique",
  'dashboards.total-overnight-conversations': "Conversations totales et de nuit (19h à 7h)",
  'dashboards.percentage-accuracy': 'Comprendre la précision',
  'dashboards.percentage-conversion': 'Trafic du site Web en conversion de chat',
  'dashboards.percentage-avatarclick': 'Trafic du site Web vers les clics d’avatar',
  'dashboards.percentage-negativefeedback': 'Commentaires négatifs en pourcentage des clics sur l`avatar',
  'dashboards.percentage-amenties': "Requêtes d'agrément",
  'dashboards.percentage-booking': 'Demandes de réservation',
  'dashboards.percentage-webchats': 'Chats sur le site Web',
  'dashboards.percentage-facebookchat': 'Chats Facebook',
  //'dashboards.number-webchattime': 'Durée totale du chat Web',

  'dashboards.number-webchattime': 'Temps total de conversation',
  'dashboards.number-totalconversation': 'Conversations totales',
  'dashboards.number-websiteconversation': 'Conversations sur le site Web',
  'dashboards.number-facebookconversation': 'Conversations sur Facebook',
  'dashboards.number-estimatedtimesaving': 'Gain de temps estimé',
  'dashboards.number-googlemapsconversation': 'Conversation Google Maps',
  'dashboards.number-whatsappconversation': 'Conversations WhatsApp',
  'dashboards.number-instagramconversation': 'Conversations sur Instagram',
  'dashboards.number-agentconversation': 'Conversations avec les agents',
  'dashboards.number-amenityqueries': "Demandes d'agrément",
  'dashboards.number-bookingenquiries': 'Demandes de réservation',
  'dashboards.number-groupbookingenquiries': 'Demandes de réservation de groupe',
  'dashboards.number-eventenquiries': "Demandes d'événements",
  'dashboards.number-longstayenquiries': 'Demandes de long séjour',
  'dashboards.number-totaltickets': 'Des billets',
  'dashboards.number-returncustomer': 'Client de retour',
  'dashboards.number-redirects': 'Redirections de site Web',
  'dashboards.number-bookingengineleads': 'Moteur de réservation',
  'dashboards.number-roomnightsreferred': "Nuitées Référées",
  'dashboards.number-revenuereferred': "Revenu référé",
  'menu.bookingsmenu': 'Réservations',
  'menu.guests': 'Informations client',
  'menu.whatsnew': "Quoi de neuf",

  'forms.forms-title': 'Former',
  'menu.formbuilder': 'Générateur de formulaires',

  'menu.virtualfrontdesk': 'Réception virtuelle',
  'menu.guestservice': 'Services à la clientèle',
  'virtual-front.common-questions': "Questions courantes",
  'virtual-front.add-on-upsells': "Add-on et ventes incitatives",
  'virtual-front.service-order': "Demande de service",
  //'virtual-front.guest-service-add-on-upsells': "Services aux invités et modules complémentaires",
  'virtual-front.guest-service-add-on-upsells': "Livre d'or numérique",
  'virtual-front.outbound': "Sortant",
  'virtual-messenger': "Messagère",

  'missed-response.missed-response-title': "Titre de la réponse manquée",
};
